export default "/images/290348e7915081d42e19177633c10d3d.avif";